import React from 'react';
import Button from '../../button';
import useLayersStore from '../../stores/layersStore';
import { captureScreenshotDomToImage } from '../../utils/screenshotUtils';

// function DrawButton() {
//     const { isDrawingMode, setIsDrawingMode, featureEnabled } = useLayersStore();
    
//     if (featureEnabled.draw) {
//         return (
//             <Button className='flex gap-1' onClick={() => setIsDrawingMode(!isDrawingMode)}>
//        <div>Draw</div>
//        <svg width="20px" height="20px" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//          <path d="M3.83331 12H6.65998C6.74772 12.0005 6.83469 11.9837 6.91592 11.9505C6.99714 11.9173 7.07102 11.8685 7.13331 11.8067L11.7466 7.18667L13.64 5.33333C13.7025 5.27136 13.7521 5.19762 13.7859 5.11638C13.8198 5.03515 13.8372 4.94801 13.8372 4.86C13.8372 4.77199 13.8198 4.68485 13.7859 4.60362C13.7521 4.52238 13.7025 4.44864 13.64 4.38667L10.8133 1.52667C10.7513 1.46418 10.6776 1.41458 10.5964 1.38074C10.5151 1.34689 10.428 1.32947 10.34 1.32947C10.252 1.32947 10.1648 1.34689 10.0836 1.38074C10.0024 1.41458 9.92862 1.46418 9.86665 1.52667L7.98665 3.41333L3.35998 8.03333C3.29819 8.09563 3.24931 8.1695 3.21613 8.25073C3.18296 8.33195 3.16614 8.41893 3.16665 8.50667V11.3333C3.16665 11.5101 3.23688 11.6797 3.36191 11.8047C3.48693 11.9298 3.6565 12 3.83331 12ZM10.34 2.94L12.2266 4.82667L11.28 5.77333L9.39331 3.88667L10.34 2.94ZM4.49998 8.78L8.45331 4.82667L10.34 6.71333L6.38665 10.6667H4.49998V8.78ZM14.5 13.3333H2.49998C2.32317 13.3333 2.1536 13.4036 2.02858 13.5286C1.90355 13.6536 1.83331 13.8232 1.83331 14C1.83331 14.1768 1.90355 14.3464 2.02858 14.4714C2.1536 14.5964 2.32317 14.6667 2.49998 14.6667H14.5C14.6768 14.6667 14.8464 14.5964 14.9714 14.4714C15.0964 14.3464 15.1666 14.1768 15.1666 14C15.1666 13.8232 15.0964 13.6536 14.9714 13.5286C14.8464 13.4036 14.6768 13.3333 14.5 13.3333Z" fill="black"/>
//                 </svg>
//             </Button>
//         );
//     }
//     return null;
// }

function ExDrawButton() {
    const { isExDrawingMode, setIsExDrawingMode, setExcalidrawBackground, featureEnabled, v3dApp, biocloudGeneratorConfig } = useLayersStore();
    
    const handleExDraw = async () => {
        if (isExDrawingMode) {
            // If already in ExDraw mode, just close it
            setIsExDrawingMode(false);
            return;
        }
        
        console.log('Taking screenshot before opening Excalidraw...');
        
        // Show progress bar
        const progressBar = document.createElement('div');
        progressBar.style.cssText = `
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: rgba(0,0,0,0.8);
            color: white;
            padding: 20px;
            border-radius: 8px;
            z-index: 9999;
            font-family: Arial, sans-serif;
        `;
        progressBar.innerHTML = '<div>Capturing background for Excalidraw...</div><div style="width: 200px; height: 4px; background: #333; margin-top: 10px; border-radius: 2px;"><div id="progress-fill" style="width: 0%; height: 100%; background: #4CAF50; border-radius: 2px; transition: width 0.3s;"></div></div>';
        document.body.appendChild(progressBar);
        
        const updateProgress = (step, total) => {
            const progressFill = document.getElementById('progress-fill');
            if (progressFill) {
                progressFill.style.width = `${(step / total) * 100}%`;
            }
        };
        
        try {
            // Pause Verge3D rendering before taking screenshot
            if (v3dApp) {
                // Store original values to restore later
                const originalFrameRateDivider = v3dApp.frameRateDivider || 1; // Default to 1 if undefined
                const originalClockRunning = v3dApp.clock ? v3dApp.clock.running : false;
                
                // Try multiple methods to stop animation
                if (v3dApp.disableRenderTrigger) {
                    v3dApp.disableRenderTrigger();
                }
                
                // Set frame rate divider to 0 to effectively stop rendering
                if (v3dApp.frameRateDivider !== undefined) {
                    v3dApp.frameRateDivider = 0;
                }
                
                // Stop the clock/animation loop
                if (v3dApp.clock && v3dApp.clock.stop) {
                    v3dApp.clock.stop();
                }
                
                // Stop all animation actions
                if (v3dApp.mixer && v3dApp.mixer.stopAllAction) {
                    v3dApp.mixer.stopAllAction();
                }
                
                // Store original values for restoration
                window._originalVerge3DState = {
                    frameRateDivider: originalFrameRateDivider,
                    clockRunning: originalClockRunning
                };
            }
            
            await captureScreenshotDomToImage(v3dApp, biocloudGeneratorConfig, setExcalidrawBackground, updateProgress);
            // Clean up progress bar
            document.body.removeChild(progressBar);
            // Open Excalidraw after screenshot is captured
            setIsExDrawingMode(true);
        } catch (error) {
            console.error('Screenshot capture failed:', error);
            // Clean up progress bar on error
            if (document.body.contains(progressBar)) {
                document.body.removeChild(progressBar);
            }
            // Re-enable Verge3D rendering on error
            if (v3dApp && window._originalVerge3DState) {
                // Restore original frame rate divider
                if (v3dApp.frameRateDivider !== undefined) {
                    v3dApp.frameRateDivider = window._originalVerge3DState.frameRateDivider || 1;
                }
                
                // Re-enable rendering
                if (v3dApp.enableRender) {
                    v3dApp.enableRender();
                }
                if (v3dApp.enableRenderTrigger) {
                    v3dApp.enableRenderTrigger();
                }
                
                // Restart the clock/animation loop
                if (v3dApp.clock && v3dApp.clock.start) {
                    v3dApp.clock.start();
                }
                
                // Clean up stored state
                delete window._originalVerge3DState;
            }
        }
    };
    
    if (featureEnabled.draw) {
        return (
            <Button className='flex gap-1' onClick={handleExDraw}>
                <div className="hidden sm:block">Draw</div>
                <svg width="20px" height="20px" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.83331 12H6.65998C6.74772 12.0005 6.83469 11.9837 6.91592 11.9505C6.99714 11.9173 7.07102 11.8685 7.13331 11.8067L11.7466 7.18667L13.64 5.33333C13.7025 5.27136 13.7521 5.19762 13.7859 5.11638C13.8198 5.03515 13.8372 4.94801 13.8372 4.86C13.8372 4.77199 13.8198 4.68485 13.7859 4.60362C13.7521 4.52238 13.7025 4.44864 13.64 4.38667L10.8133 1.52667C10.7513 1.46418 10.6776 1.41458 10.5964 1.38074C10.5151 1.34689 10.428 1.32947 10.34 1.32947C10.252 1.32947 10.1648 1.34689 10.0836 1.38074C10.0024 1.41458 9.92862 1.46418 9.86665 1.52667L7.98665 3.41333L3.35998 8.03333C3.29819 8.09563 3.24931 8.1695 3.21613 8.25073C3.18296 8.33195 3.16614 8.41893 3.16665 8.50667V11.3333C3.16665 11.5101 3.23688 11.6797 3.36191 11.8047C3.48693 11.9298 3.6565 12 3.83331 12ZM10.34 2.94L12.2266 4.82667L11.28 5.77333L9.39331 3.88667L10.34 2.94ZM4.49998 8.78L8.45331 4.82667L10.34 6.71333L6.38665 10.6667H4.49998V8.78ZM14.5 13.3333H2.49998C2.32317 13.3333 2.1536 13.4036 2.02858 13.5286C1.90355 13.6536 1.83331 13.8232 1.83331 14C1.83331 14.1768 1.90355 14.3464 2.02858 14.4714C2.1536 14.5964 2.32317 14.6667 2.49998 14.6667H14.5C14.6768 14.6667 14.8464 14.5964 14.9714 14.4714C15.0964 14.3464 15.1666 14.1768 15.1666 14C15.1666 13.8232 15.0964 13.6536 14.9714 13.5286C14.8464 13.4036 14.6768 13.3333 14.5 13.3333Z" fill="black"/>
                </svg>
            </Button>
        );
    }
    return null;
}

function ScreenshotButton() {
    const { setScreenshot, featureEnabled, v3dApp, biocloudGeneratorConfig } = useLayersStore();
    
    const handleScreenshot = async () => {
        console.log('Taking screenshot...');
        
        // Show progress bar
        const progressBar = document.createElement('div');
        progressBar.style.cssText = `
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: rgba(0,0,0,0.8);
            color: white;
            padding: 20px;
            border-radius: 8px;
            z-index: 9999;
            font-family: Arial, sans-serif;
        `;
        progressBar.innerHTML = '<div>Capturing screenshot...</div><div style="width: 200px; height: 4px; background: #333; margin-top: 10px; border-radius: 2px;"><div id="progress-fill" style="width: 0%; height: 100%; background: #4CAF50; border-radius: 2px; transition: width 0.3s;"></div></div>';
        document.body.appendChild(progressBar);
        
        const updateProgress = (step, total) => {
            const progressFill = document.getElementById('progress-fill');
            if (progressFill) {
                progressFill.style.width = `${(step / total) * 100}%`;
            }
        };
        
                try {
                    await captureScreenshotDomToImage(v3dApp, biocloudGeneratorConfig, setScreenshot, updateProgress);
                    // Clean up progress bar on success
                    document.body.removeChild(progressBar);
                } catch (error) {
            console.error('Screenshot failed:', error);
            // Clean up progress bar on error
            if (document.body.contains(progressBar)) {
                document.body.removeChild(progressBar);
            }
        }
    };

    if (featureEnabled.screenShot) {
        return (
            <Button className='flex gap-1' onClick={handleScreenshot}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>
                <div className='hidden sm:block'>Screenshot</div>
                <div className="sm:hidden">SS</div>
            </Button>
        );
    }
    return null;
}

export default DrawButton; 
export { ExDrawButton, ScreenshotButton };

